import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
const ConfirmDeleteAction = ({ children }) => {
    return _jsx("div", { className: 'modal-content confirm-delete-action', children: children });
};
export default ConfirmDeleteAction;
